import { SvgIconProps } from '@mui/material';

const DesktopArrowRight = ({ width = '124', height = '209', className }: SvgIconProps) => (
  <svg width={width} height={height} viewBox="0 0 124 209" fill="none" className={className}>
    <g filter="url(#filter0_d_7450_372016)">
      <path
        d="M5.11081 143.794C3.63042 143.059 3.63042 140.947 5.11081 140.211L23.2197 131.217C24.5492 130.556 26.1094 131.523 26.1094 133.008L26.1094 150.997C26.1094 152.482 24.5492 153.449 23.2197 152.789L5.11081 143.794Z"
        fill="#E8E6DF"
      />
      <path
        d="M117.891 2V127C117.891 135.837 110.727 143 101.891 143H24.1094"
        stroke="#E8E6DF"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_7450_372016"
        x="0"
        y="0"
        width="123.891"
        height="217"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7450_372016" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7450_372016"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DesktopArrowRight;
